<template>
  <span>
    <a class="cursor-pointer" @click="() => changeReachedInfo(paiTargetId)" href="javascript:void(0)">
      <span v-if="reachedId == 2">
        <i class="fa-light fa-face-smile green"></i>
        <span class="green text-uppercase">{{ reached }}</span>
      </span>
      <span v-else-if="reachedId == 1">
        <i class="fa-light fa-face-meh yellow"></i>
        <span class="yellow text-uppercase">{{ reached }}</span>
      </span>
      <span v-else-if="reachedId == 0">
        <i class="fa-light fa-face-frown red"></i>
        <span class="red text-uppercase">{{ reached }}</span>
      </span>
      <span v-else-if="reachedId">
        <span class="text-uppercase">{{ reached }}</span>
        <br />
      </span>
      <span v-else>
        <i class="fa-light fa-chevron-right"></i>
      </span>
    </a>
    <span v-if="dataVer">{{ dataVer }}</span>
  </span>
</template>

<script>
import apiConnector from '@/epersonam/apiConnector';

export default {
  name: 'reachedLinkChange',
  props: ['reached', 'dataVer', 'paiTargetId', 'reachedId', 'reachedUrl'],
  methods: {
    changeReachedInfo() {
      Loader.show();
      apiConnector()
        .get(this.reachedUrl.replace('PAIS_TARGET_ID', this.paiTargetId))
        .then((res) => {
          $('#content-edit-targets-previous').html(res['data']);
          $('#modal-edit-targets-previous').modal('show');
          window.updateVueInstances();
          $('#form-management-pais-target').bind('ajax:success', (evt, data, status, xhr) => {
            // eslint-disable-next-line vue/no-mutating-props
            this.dataVer = data['data_ver'];
            // eslint-disable-next-line vue/no-mutating-props
            this.reachedId = data['reached'];
            // eslint-disable-next-line vue/no-mutating-props
            this.reached = data['get_reached'];
            $('#modal-edit-targets-previous').modal('hide');
          });
          window.loadGenericFunction();
          Loader.hide();
        })
        .catch((err) => {
          Loader.hide();
        });
    },
  },
};
</script>
